/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ player: NonNullable<unknown> }} Err_Tournament_Player_Not_In_RoundInputs */



/**
* | output |
* | --- |
* | "Player {player} not found in current round seating" |
*
* @param {Err_Tournament_Player_Not_In_RoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_player_not_in_round = /** @type {((inputs: Err_Tournament_Player_Not_In_RoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Player_Not_In_RoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le joueur ${i?.player} n'est pas dans le placement de la ronde en cours`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El jugador ${i?.player} no está en los asientos de la ronda actual`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`O jogador ${i?.player} não está nos assentos da rodada atual`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il giocatore ${i?.player} non è nella disposizione del round corrente`)
	return /** @type {LocalizedString} */ (`Player ${i?.player} not found in current round seating`)
});